import { render, staticRenderFns } from "./tmOverlaySpan.vue?vue&type=template&id=119a8fa9&"
import script from "./tmOverlaySpan.vue?vue&type=script&lang=js&"
export * from "./tmOverlaySpan.vue?vue&type=script&lang=js&"
import style0 from "./tmOverlaySpan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports